import ProjectUserSession from "./project-user-session";
import {ProjectAccess, ProjectRole} from "../../gd/const/project";
import FieldProto from "../../fields3/proto/field-proto";
import Session_reinitNavigationStructure from "../../gd-session/functions/reinit-navigation-structure";

// this is very custom collection implemented with INDEX (!) for speed and perforemance

// VAZNO
// we always filter teams to support old code - see special methods if you need teams data

export default class ProjectUsersSessionCollection {

    // private indexMap                : Map<ID, number> = new Map();  // model.id -> position in array

    private idIndex                 : Map<ProjectUserSession["id"], number> = new Map();
    private projectIndex            : Map<ProjectUserSession["projectId"], Set<ProjectUserSession["id"]>> = new Map() // projectID -> SET(userId1, userId2)

    public models                   : ProjectUserSession[] = []



    constructor(models:ProjectUserSession[]=[]) {

        if (models) {
            this.reset(models)
        }

    }

    // INIT

    static initFromJson(data:JSONArray):ProjectUsersSessionCollection {

        // @ts-ignore
        const models : ProjectUserSession[] = _.map(data, (modelData:JSONObject):ProjectUserSession =>{
            // return new ProjectUser(modelData)
            return new ProjectUserSession(modelData)
        })

        const collection = new ProjectUsersSessionCollection(models)
        return collection
    }

    // GET

    get(id: ProjectUserSession["id"]): ProjectUserSession | undefined {
        const idx = this.idIndex.get(id);
        return idx === undefined ? undefined : this.models[idx];
    }

    getByProjectId(projectId: ProjectUserSession["projectId"]): ProjectUserSession[] {
        const ids = this.projectIndex.get(projectId);
        if (!ids) return [];
        const out: ProjectUserSession[] = [];
        for (const id of ids) {
            const idx = this.idIndex.get(id);
            if (idx !== undefined) out.push(this.models[idx]);
        }
        return out;
    }

    // Return IDS of users in this project (not teams)
    projectUserIds(projectId:ID, minAccess?:ProjectAccess):ID[] {

        const projectUsers : ProjectUserSession[] = this.getByProjectId(projectId)

        const result : ID[] = []

        _.map(projectUsers, (projectUser:ProjectUserSession) => {

            if (projectUser.isUser && projectUser.user) {

                if (_.isNil(minAccess)) {
                    result.push(projectUser.userId)
                } else {
                    if (projectUser.access >= minAccess) {
                        result.push(projectUser.userId)
                    }
                }


            }
        })

        return result
    }

    // Return IDS of teams in this project (not users)
    projectTeamIds(projectId:ID) {
        return this.projectTeams(projectId).map((projectUser:ProjectUserSession)=>{
            return projectUser.teamId
        })
    }

    projectTeams(projectId:ID):ProjectUserSession[] {

        const projectUsers : ProjectUserSession[] = this.getByProjectId(projectId)

        return _.filter(projectUsers, (projectUser:ProjectUserSession)=>{
            return projectUser.isTeam && projectUser.access
        }) as ProjectUserSession[]
    }




    // ADD

    add(projectUser:ProjectUserSession | null) {

        // this helps dealing with factory which return null...
        if (!projectUser) return


        if (this.idIndex.has(projectUser.id)) {
            return; // skip duplicates (or implement upsert)
        }

        this.models.push(projectUser)

        this.idIndex.set(projectUser.id, this.models.length - 1);

        let set = this.projectIndex.get(projectUser.projectId);
        if (!set) {
            set = new Set();
            this.projectIndex.set(projectUser.projectId, set);
        }

        set.add(projectUser.id);

    }


    // REMOVE

    remove(id: ProjectUserSession["id"]): void {
        const idx = this.idIndex.get(id);
        if (idx === undefined) return;

        const projectUserToDelete = this.models[idx];
        const lastIdx = this.models.length - 1;
        const last = this.models[lastIdx];

        // swap-with-last
        this.models[idx] = last;
        this.idIndex.set(last.id, idx);

        // pop victim
        this.models.pop();
        this.idIndex.delete(projectUserToDelete.id);

        // clean projectIndex
        const set = this.projectIndex.get(projectUserToDelete.projectId);
        if (set) {
            set.delete(projectUserToDelete.id);
            if (set.size === 0) this.projectIndex.delete(projectUserToDelete.projectId);
        }
    }

    removeModel(modelToDelete:ProjectUserSession) {
        return this.remove(modelToDelete.id)
    }




    // RESET

    reset(models?:ProjectUserSession[]) {
        // this.models    = [] // deprecated ? see chat gpt
        this.models.length = 0; // recommended !

        this.idIndex.clear();
        this.projectIndex.clear();


        _.map(models, model=>{
            this.add(model)
        })

        // !silent && this.triggerBusEvent("reset")
    }

    resetFromData(records:JSONArray) {

        const models : ProjectUserSession[] = _.map(records, (record:JSONObject)=>{
            return new ProjectUserSession(record)
        }) as unknown as ProjectUserSession[]

        this.reset(models)

    }

    // BUS

    // private triggerBusEvent(calledBy?:string):void {
    //     gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED, {from: calledBy})
    // }

    // GENERAL GETERS

    // old used in gd.sessionCustomViews ?
    get all() {
        return this.models
    }

    get items() {
        return this.models
    }

    get isEmpty() {
        return !this.models || this.models.length < 1
    }

    get length():number {
        return this.models ? this.models.length : 0
    }




    // AMPERSAND METHODS - OLD

    map(callback:func) {
        return _.map(this.models, (item, key)=>callback(item, key));
    }

    // RESET

    resetByProject(projectId:ID,newRecords:JSONArray) {
// console.log("resetByProject projectId=",projectId)
// console.log("reset by projectId=", projectId, "records=", data.length)

        const sessionProject = gd.session.projects.get(projectId);
        if (!sessionProject || sessionProject.isTemplate) return; // no users for template projects

        // silently remove current records

        _.each(this.getByProjectId(projectId),model=>{
            this.removeModel(model)
        });

        // old
        // const oldUsersArr = this.models.filter(projectUser=>projectUser.project.id === projectId);
        // _.each(oldUsersArr,model=>{
        //     this.removeSilent(model.id)
        // });

        // now we do it in session handler
        // temporary fix to remove users for projects not present in gd.session.projects - THIS IS NEED FIX as pu relays on project model...
        // const newRecords = _.remove(data.slice(), (data:any)=>gd.session.projects.get(data.projectId) != null);

        const newModels = _.map(newRecords, (record)=>{
            return new ProjectUserSession(record)
        })

        _.map(newModels, (model)=>{
            this.add(model)
        })


        // I think we DO need it
        // we keep access in session.projectUsers & session.projects
        // so when update projectUsers need update project.access
        // for current user only
        _.map(newModels, (projectUser:ProjectUserSession)=>{
            if (projectUser.userId === gd.user.id
                && sessionProject.id === projectUser.projectId
                && sessionProject.access !== projectUser.access)
            {
                sessionProject.access = projectUser.access!
            }
        })

    }

    resetForManyProjects(records:JSONArray) {

        // temporary fix to remove users for projects not present in gd.session.projects - THIS IS NEED FIX as pu relays on project model...
        const projectUserRecords = _.remove(records as JSONObject[], (data:any)=>{
            return gd.session.projects.get(data.projectId) != null
        });

        const groupedByProject = _.groupBy(projectUserRecords, 'projectId');

        _.map(groupedByProject, (projectUsers, projectId)=>{


            // Why do we want to keep old models ? no idea...


            // const previousCollectionModels:ProjectUserSession[] = _.clone(this.models)

            this.resetByProject(projectId, projectUsers)


            // // why do we need it ???
            // // add models that are missing in new session Collection
            // // and mark as no access in order not to appear in project users lists
            // _.map(previousCollectionModels, (model:ProjectUserSession) => {
            //     if (!this.get(model.id)) {
            //         model.access = null
            //         this.addSilent(model)
            //     }
            // })




        })

        Session_reinitNavigationStructure()

    }


    resetAndKeepOldModels(data:JSONArray, options: {  } = {}) {

        // Why do we want to keep old models ? no idea...

        // const previousCollectionModels:ProjectUserSession[] = _.clone(this.models)

        this.resetFromData(data)

        // // why do we need it ???
        // // add models that are missing in new session Collection
        // // and mark as no access in order not to appear in project users lists
        // _.map(previousCollectionModels, (model:ProjectUserSession) => {
        //     if (!this.get(model.id)) {
        //         model.access = null
        //         this.add(model)
        //     }
        // })

        // !options.silent && this.triggerBusEvent()
    }

    findFullAccessUsers():ProjectUsersSessionCollection {
        return new ProjectUsersSessionCollection(_.filter(this.models, (m)=>{
            return m.access === ProjectAccess.FULL
        }))
    }


    public notClients(projectId:ID):ProjectUserSession[] {
        // projectIndex lookup instead of scanning all models - called per row by the tag access mode field
        return _.filter(this.getByProjectId(projectId), (projectUser)=>{
            return projectUser.access
                && !projectUser.isClient
                && !projectUser.isTeam
        })
    }

    public clients(projectId:ID):ProjectUserSession[] {
        return _.filter(this.getByProjectId(projectId), (projectUser)=>{
            return projectUser.access
                && projectUser.isClient
        })
    }


    // FIND

    /*
    findProjectManager() {
        let pu = false;
        this.models.map(m=>{
            if (m.projectRole === gd.const.project.role.PROJECT_MANAGER) {
                pu = m;
            }
        });
        return pu;
    }
     */

    findProjectOwner() : ProjectUserSession | false {

        let po : ProjectUserSession | false = false;
        this.models.map(m=>{
            if (m.projectRole === ProjectRole.OWNER) {
                po = m;
            }
        });
        return po
    }


    // FILTER METHODS

    filterByProject(projectId:ID, minAccess?:ProjectAccess, includeTeams?:boolean):ProjectUsersSessionCollection {

        // const models : ProjectUserSession[] = this.models.filter((m : ProjectUserSession) => {
        //     return m.projectId === projectId && m.access && (!minAccess || m.access >= minAccess)
        // })

        includeTeams = includeTeams || false

        const models : ProjectUserSession[] = _.filter(
            this.getByProjectId(projectId),
            (projectUser : ProjectUserSession) => {

                if (includeTeams) {
                    return projectUser.access && (!minAccess || projectUser.access >= minAccess)
                } else {
                    return projectUser.isUser && projectUser.access && (!minAccess || projectUser.access >= minAccess)
                }

            }
        ) as unknown as ProjectUserSession[]


        return new ProjectUsersSessionCollection(models)
    }

    filterByProjectNotReadOnly(projectId:ID, includeTeams?:boolean):ProjectUsersSessionCollection {

        includeTeams = includeTeams || false
        const setAccess = new Set([ProjectAccess.FULL, ProjectAccess.STANDARD, ProjectAccess.LIMITED]);

        const models = _.filter(this.getByProjectId(projectId), (projectUser:ProjectUserSession)=>{

            if (includeTeams) {
                return projectUser.access && setAccess.has(projectUser.access)
            } else
                return projectUser.isUser && projectUser.access && setAccess.has(projectUser.access)


        }) as unknown as ProjectUserSession[]


        return new ProjectUsersSessionCollection(models)
    }

    filterByProjects(projectIds: ID[], minAccess?: ProjectAccess) {
        // return new ProjectUsers(this.filter(m => m.access && projectIds.indexOf(m.project.id) > -1), {parse:false});
        return new ProjectUsersSessionCollection(this.models.filter((projectUser: ProjectUserSession) => {
            return projectUser.access && projectIds.includes(projectUser.projectId) && (!minAccess || !projectUser.access || projectUser.access >= minAccess)
        }))
    }

    filterByUser(userId:ID, minAccess?:ProjectAccess) {
        // return new ProjectUsers(this.filter(m=>m.user.id === userId && (!minAccess || m.access >= minAccess)),{parse:false});
        return new ProjectUsersSessionCollection(this.models.filter((m)=>m.userId === userId && (!minAccess || !m.access || m.access >= minAccess)))
    }

    filterByUserAndRole(userId:ID, projectRole:ProjectRole) {
        // return new ProjectUsers(this.filter(m=>m.user.id === userId && m.projectRole >= projectRole),{parse:false});
        return new ProjectUsersSessionCollection(this.models.filter((m)=>m.userId === userId && m.projectRole >= projectRole));
    }

    // can be undefined !!!
    findByProjectAndUser(projectId:ID, userId:ID):ProjectUserSession {
        return this.get(projectId+"-"+userId)!
    }




    // EXPORT


    exportToOptions():Options {
        const result : Options = []
        this.models.map(m=>{

            result.push({
                value   : m.user.id,
                label   : m.user.name,
                icon    : m.user.icon,
                // @ts-ignore
                iconObj : m.user
            })
        });

        return result;
    }

    exportToArrayUserId():ID[] {
        return this.models.map((pu)=>{
            return pu.userId
        });
    }


    toJSON():any {
        return _.map(this.models, (model)=>{
            return model.toJSON()
        })
    }

    exportToCSV(arrayOfFields:FieldProto[], arrayOfIds:fieldId[], fileName: string = 'file-name') {
        throw Error("Not implemented #kdjsi")
    }





}




